<script lang="ts">
  import MaintainerStatus from '#lib/components/MaintainerStatus.svelte';
  import DataTable from '#lib/components/data-table/DataTable.svelte';
  import type { TableRow } from '#lib/zod/output/TabularData.js';

  const { data } = $props();

  const rows = $derived<TableRow[]>(
    data.maintainers.map((m) => ({
      type: 'leaf',
      id: m.id,
      name: m.displayName ?? m.id,
      parameters: { status: 'online', type: m.type },
      tags: [],
      data: {},
    })),
  );
</script>

{#snippet status(row: TableRow)}
  <div class="text-center!">
    <MaintainerStatus status={{ status: row.parameters.status as any }} />
  </div>
{/snippet}

<DataTable
  nameColTitle="Connected system"
  cols={[
    { title: 'Type', type: 'parameter', parameter: 'type' },
    { title: 'Status', type: 'custom', snippet: status },
  ]}
  {rows}
/>
